var React = require('react');

function Tie (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M124.3,0c-0.1,0-0.18,0.03-0.26,0.08c-0.01,0-0.02,0-0.02,0l-15.29,8.83l-14.65,8.77l0,0c-0.16,0.1-0.36,0.1-0.52,0l0,0  L78.9,8.91L63.57,0.07h-0.01c-0.07-0.03-0.15-0.06-0.23-0.06c-0.29,0-0.53,0.24-0.53,0.53v35.33c0,0.29,0.24,0.53,0.53,0.53  c0.09,0,0.18-0.03,0.25-0.07h0.01l15.3-8.83l14.66-8.77c0.16-0.1,0.35-0.1,0.51,0l14.66,8.77l15.31,8.84h0.01  c0.07,0.04,0.15,0.06,0.24,0.06c0.29,0,0.53-0.24,0.53-0.53V0.54C124.83,0.23,124.59,0,124.3,0z","fill":"#000000"}));
}

Tie.defaultProps = {"viewBox":"62.800000000000004 0 62.01 36.400000000000006"};

module.exports = Tie;

Tie.default = Tie;
